import { Donvi } from './donvi';

export class Lienhe {
    id: number;
    hoten: string;
    diachi: string;
    thudientu: string;
    dienthoai: string;
    tieude: string;
    noidung: string;
    taptin: string;
    duyet: number;
    noidungtraloi: string;
    taptintl: string;
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifieddate: Date;
    modifiedbyuserid: number;
    donviid: number;
    dmDonvi: Donvi;
    tendonvi: string;
    showanswer: boolean = false;
    getFiles: string[];
    getFilesTl: string[];
    markread: number;
    tenclass: string;
    noidungrutgon: string;
}